import { render, staticRenderFns } from "./createCrossRecordNode.vue?vue&type=template&id=50d7d71d&scoped=true&"
import script from "./createCrossRecordNode.vue?vue&type=script&lang=js&"
export * from "./createCrossRecordNode.vue?vue&type=script&lang=js&"
import style0 from "./createCrossRecordNode.vue?vue&type=style&index=0&id=50d7d71d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d7d71d",
  null
  
)

export default component.exports